import { Palette } from '@mui/material/styles';

import { palette } from './palette-var';

export const createPalette = (): Omit<
  Palette,
  | 'contrastThreshold'
  | 'common'
  | 'getContrastText'
  | 'grey'
  | 'secondary'
  | 'tonalOffset'
  | 'type'
  | 'augmentColor'
> => {
  return {
    mode: 'light',
    ...palette,
  };
};
